import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53eac524"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass([
      'drop-down__item',
      { ganhemais: _ctx.item.name === 'Meus treinamentos' && _ctx.isCirculoTemplate() },
      {
        active:
          _ctx.item.route &&
          _ctx.route.name === _ctx.item.route.name &&
          (!_ctx.item.route.params?.option ||
            _ctx.route.params.option === _ctx.item.route.params?.option)
      }
    ]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToRoute && _ctx.goToRoute(...args)))
  }, [
    (_ctx.item.image)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          width: "20",
          height: "20",
          src: require(`../../../../assets/static/main-menu/${_ctx.item.image}`),
          alt: "Ícone"
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_ctx.item.name), 1)
  ], 2))
}